import React from 'react';
import { ArrowRightIcon, RocketIcon } from 'lucide-react';
export const CHECKOUT_URL = 'https://mega-kit-integracion-campo-plc-scada-2026.impultienda.ar/checkout';
interface CtaButtonProps {
  label?: string;
  size?: 'md' | 'lg';
  className?: string;
  /** Defaults to scrolling to the offer section; pass CHECKOUT_URL to go straight to payment. */
  href?: string;
  /** 'copper' works on light backgrounds, 'gold' on the dark offer card. */
  variant?: 'copper' | 'gold';
  fullWidth?: boolean;
}
export function CtaButton({
  label = 'Quiero Mi Mega Kit Ahora',
  size = 'lg',
  className = '',
  href = '#oferta',
  variant = 'copper',
  fullWidth = false
}: CtaButtonProps) {
  const isExternal = href.startsWith('http');
  const sizing = size === 'lg' ? 'px-9 py-4 text-lg' : 'px-6 py-3 text-base';
  const tone = variant === 'gold' ? 'bg-ember-400 text-forest-900 hover:bg-[#F2B653] focus-visible:outline-ember-400' : 'bg-ember-500 text-white hover:bg-ember-600 focus-visible:outline-ember-500';
  return <a href={href} {...isExternal ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} className={`inline-flex items-center justify-center gap-2.5 rounded-full font-semibold shadow-lift transition-[transform,background-color] duration-150 ease-out hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 active:translate-y-0 ${sizing} ${tone} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-46" data-mp="35yh880vc5245">
      {variant === 'gold' ? null : <RocketIcon className="h-5 w-5" aria-hidden="true" data-id="element-47" data-mp="3swasavkg01ca" />}
      {label}
      {variant === 'gold' ? <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-48" data-mp="1jzc9d50tlof" /> : null}
    </a>;
}